module.exports = __webpack_public_path__ + "static/SNG4-0af1f22dd4a7c6c5f0e42336074e406c.png";